import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import React, { useEffect, useState } from "react";
import { Graph } from "src/generated/graph";
import styles from "./style.module.scss";

const QUERY_MAP_SUGGESTION_PLACE = gql`
  query MapSuggestionPlace($keyword: String) {
    mapSuggestionPlace(keyword: $keyword) {
      name
      placeId
    }
  }
`;

const QUERY_MAP_PLACE_ADDRESS = gql`
  query MapPlaceLocation($placeId: String) {
    mapPlaceLocation(placeId: $placeId) {
      lat
      lng
    }
  }
`;

interface InfoAddress {
  searchResult: Graph.MapPlaceSuggestion[];
  onSelectResult: (place: Graph.MapPlaceSuggestion) => void;
}

function SearchAddressList(props: InfoAddress) {
  return (
    <div>
      {props?.searchResult && props?.searchResult.length > 0 && (
        <ul>
          {props?.searchResult.map((x, i) => (
            <li key={i} onClick={() => props?.onSelectResult(x)}>
              {x?.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

interface Info {
  address: string;
  enableClick: boolean;
  setEnableClick: (enableClick: boolean) => void;
  onChangeAddress: ({ lat, lng, address }: { lat: number; lng: number; address?: string }) => void;
  noEnabled?: boolean;
}

function SearchMapAddress(props: Info) {
  const [placeId, setPlaceId] = useState<string | null>(null);
  const [searchAddress, setSearchAddress] = useState("");
  const [places, setPlaces] = useState<Graph.MapPlaceSuggestion[]>([]);
  const [getDetail, { loading: searching }] = useLazyQuery<{
    mapSuggestionPlace: Graph.MapPlaceSuggestion[];
  }>(QUERY_MAP_SUGGESTION_PLACE, { onCompleted: (r) => setPlaces(r.mapSuggestionPlace || []) });

  const [getAddressLatLng, { loading: finding }] = useLazyQuery<{
    mapPlaceLocation: Graph.MapPlaceLoationResponse;
  }>(QUERY_MAP_PLACE_ADDRESS, {
    onCompleted: (r) => {
      if (props.onChangeAddress) {
        props.onChangeAddress({
          address: searchAddress,
          lat: Number(r.mapPlaceLocation.lat),
          lng: Number(r.mapPlaceLocation.lng),
        });
      }
    },
  });

  const onSelectResult = (place: Graph.MapPlaceSuggestion) => {
    setPlaces([]);
    setSearchAddress(place?.name?.toString() || "");
    setPlaceId(place?.placeId || null);
    getAddressLatLng({ variables: { placeId: place.placeId } });
  };

  useEffect(() => {
    if ((props.address || "").trim() !== searchAddress.trim()) {
      setSearchAddress(props.address);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.address]);

  useEffect(() => {
    if (!!searchAddress.trim() && !placeId && (props.address || "").trim() !== searchAddress.trim()) {
      places.length > 0 && setPlaces([]);
      const timer = setTimeout(() => getDetail({ variables: { keyword: searchAddress } }), 1000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchAddress, props.address]);

  return (
    <div style={{ position: "relative" }}>
      <div className={styles.address_search_map}>
        <div className={styles.search}>
          {(searching ||
            finding ||
            (!!searchAddress.trim() &&
              places.length === 0 &&
              !placeId &&
              (props.address || "").trim() !== searchAddress.trim())) && (
            <p>
              <i className="fa fa-spinner fa-spin" style={{ fontSize: 15 }} />
            </p>
          )}
          <input
            type="text"
            autoFocus
            value={searchAddress}
            placeholder="ស្វែងរកទីតាំង..."
            onChange={(e) => {
              !!placeId && setPlaceId(null);
              setSearchAddress(e.currentTarget.value);
            }}
          />
        </div>
        {!props.noEnabled && (
          <div className={styles.enableClick}>
            <label>
              <div>
                <input
                  type="checkbox"
                  checked={props?.enableClick}
                  onChange={() => props?.setEnableClick(!props?.enableClick)}
                  name="fordCheckBox"
                />
              </div>
              <span>Click here to pin location</span>
            </label>
          </div>
        )}
        <SearchAddressList searchResult={places} onSelectResult={onSelectResult} />
      </div>
    </div>
  );
}

export default SearchMapAddress;
